var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64288 0.958862C1.43489 0.958862 1.23542 1.04149 1.08834 1.18856C0.941268 1.33564 0.858643 1.53511 0.858643 1.7431L0.858643 14.291L8.48774 19.7313C8.55431 19.7789 8.63411 19.8045 8.71596 19.8045C8.79781 19.8045 8.87761 19.7789 8.94417 19.7313L16.5435 14.291V1.7431C16.5435 1.53511 16.4608 1.33564 16.3138 1.18856C16.1667 1.04149 15.9672 0.958862 15.7592 0.958862H1.64288Z",
    fill: "black",
    fillOpacity: 0.556545
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.8d54760cfb77a3152c43e304908c14d1.svg";
export { ForwardRef as ReactComponent };